import { Space as AntSpace } from 'antd'

import styled from 'styled-components'

const Space = styled(AntSpace)``

export default Space